import { Component } from '@angular/core';
import { OrderService } from '../services/order.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tracking-details',
  templateUrl: './tracking-details.component.html',
  styleUrl: './tracking-details.component.css'
})
export class TrackingDetailsComponent {

  constructor(private orderService: OrderService, private route: ActivatedRoute) {

  }

  currentIndex = 0;
  history: any[] = [];

  statusSteps = ["Order Processing", "Packed", "Shipped", "Delivered"];

  ngOnInit() {
    const param = this.route.snapshot.paramMap.get('orderId');

    if (param !== null) {
      const orderId = Number(param); // convert to number


      this.orderService.getOrderTracking(orderId).subscribe((res: any) => {
        this.history = res.history;
        this.currentIndex = this.statusSteps.indexOf(res.currentStatus);
      });
    }
  }
}
